import axiosConfig from "./axiosConfig";
import { AxiosError } from "axios";
import ApiError from "../utils/ApiError";
import {
  AlertTypeResponse,
  AlertHistoryResponse,
  AlertResponse,
} from "./types";
import moment from "moment";

interface PaginationResponse {
  data: Array<AlertTypeResponse>;
  numberOfTotalDevices: number;
}

export async function getAlerts(
  title: any = ""

): Promise<PaginationResponse> {
  try {
    let url = '/admin/alerts-types';
    if (title) {
      url = `/admin/alerts-types?title=${title}`;
    }
    const response = await axiosConfig.get(url);
    const data = response.data.data as Array<AlertTypeResponse>;
    return { data, numberOfTotalDevices: response.data.meta.total };
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function alertsReorder(
  body: Record<string, any>
): Promise<PaginationResponse> {
  try {
    let url = '/admin/alerts-types/reorder';
    const response = await axiosConfig.post(url, body); // 👈 POST method with body

    const data = response.data.data as Array<AlertTypeResponse>;
    return { data, numberOfTotalDevices: response.data.meta.total };
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}


export async function getAlertType(
  title: any = "",
  page: any
): Promise<PaginationResponse> {
  try {
    let url = `/admin/alert-type?page=${page}&limit=10`;
    if (title) {
      url = `/admin/alert-type?title=${title}`;
    }
    const response = await axiosConfig.get(url);
    const data = response.data.data as Array<AlertTypeResponse>;
    return { data, numberOfTotalDevices: response.data.meta.total };
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}



export async function sendQuickAlert(body: any): Promise<PaginationResponse> {
  try {
    const response = await axiosConfig.post("/admin/send-quick-alert", body);
    const data: any = response.data.data as Array<any>;
    return data;
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function saveSchoolDetail(body: any): Promise<PaginationResponse> {
  try {
    const response = await axiosConfig.post("/admin/organization-details", body);
    const data: any = response.data.data as Array<any>;
    return data;
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getSchoolDetails(): Promise<PaginationResponse> {
  try {
    const response = await axiosConfig.get("/admin/organization-details");
    const data: any = response.data.data;
    return data;
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getAlertCategory(
  title: any = ""
): Promise<PaginationResponse> {
  try {
    const response = await axiosConfig.get(`/admin/alert-categories?title=${title}`);
    const data = response.data.data as Array<AlertTypeResponse>;
    return { data, numberOfTotalDevices: response.data.meta.total };
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getAlertTypeCategory(
  title: any = "",
  page: any
): Promise<PaginationResponse> {
  try {
    const response = await axiosConfig.get(`/admin/alert-category?title=${title}&page=${page}&limit=10`);
    const data = response.data.data as Array<AlertTypeResponse>;
    return { data, numberOfTotalDevices: response.data.meta.total };
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function notificationSounds(): Promise<PaginationResponse> {
  try {
    const response = await axiosConfig.get("/admin/notification-sounds");
    const data = response.data.data as Array<AlertTypeResponse>;
    return { data, numberOfTotalDevices: response.data.meta.total };
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function createNewAlertType(
  name: string,
  color: string,
  icon: any,
  category: any,
  isDefault: boolean,
  isHomeAlert: boolean,
  notification_sound_id: any = "",
): Promise<void> {
  const form = new FormData();
  form.append("name", name);
  form.append("color", color);
  if (icon) {
    form.append("icon", icon);
  }
  if (category) {
    form.append("alert_category_id", category);
  }
  if (notification_sound_id) {
    form.append("notification_sound_id", notification_sound_id);
  }
  form.append("isDefault", isDefault.toString());
  form.append("is_home_alert", isHomeAlert.toString());
  //   name, color, alert_category_id: category, isDefault
  try {
    await axiosConfig.post("/admin/alert-types-post", { name, color, icon, alert_category_id: category, isDefault, isHomeAlert: isHomeAlert, notification_sound_id }, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
  } catch (e: any) {
    const err = e as AxiosError | Error;
    // if we throw thru "ApiError" we lost error properties like original api message property
    // throw new ApiError(err);
    throw err;
  }
}

export async function createNewAlertCategory(
  name: string,
  category: false | any,
): Promise<void> {
  try {
    await axiosConfig.post("/admin/alert-categories", { name, alert_type_ids: category }, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    });
  } catch (e: any) {
    const err = e as AxiosError | Error;
    // if we throw thru "ApiError" we lost error properties like original api message property
    // throw new ApiError(err);
    throw err;
  }
}

export async function deleteAlertType(alertTypeId: string): Promise<void> {
  try {
    await axiosConfig.delete(`/admin/alerts-types/${alertTypeId}`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function deleteAlertCategory(alertTypeId: string): Promise<void> {
  try {
    await axiosConfig.delete(`/admin/alert-categories/${alertTypeId}`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function updateAlertType(name: string, color: string, icon: any, category: any, id: string, notification_sound_id: any = ""): Promise<void> {
  try {
    await axiosConfig.patch(`/admin/alerts-types/${id}`, { name, color, icon, alert_category_id: category, notification_sound_id });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function updateAlertCategory(name: string, category: any, id: string): Promise<void> {
  try {
    await axiosConfig.put(`/admin/alert-categories/${id}`, { name, alert_type_ids: category });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function throwAlertById(
  alertId: number,
  userId: number
): Promise<void> {
  try {
    await axiosConfig.post(`/admin/alerts-types/throw-alert/new`, {
      alertId,
      userId,
    });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function setAlertDefaultById(alertId: number) {
  try {
    await axiosConfig.patch(`/admin/alerts-types/${alertId}`, {
      isDefault: true,
    });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getAlertTypeLength(alertId: number) {
  try {
    const response = await axiosConfig.get(`/admin/alerts-type-actions-count/${alertId}`);
    return response.data; // 👈 response return karo
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function setHomeAlert(alertId: number, checked: any) {
  try {
    const response = await axiosConfig.put(`/admin/alerts-types/${alertId}`, {
      isHomeAlert: checked,
    });
    return response; // <-- Yahan return kar rahe hain
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}


export async function setAutoAlert(alertId: number, checked: any) {
  try {
    await axiosConfig.put(`/admin/alerts-types-auto-send/${alertId}`, {
      autoSend: checked,
    });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}
export async function setHiddenAlert(alertId: number, checked: any) {
  try {
    await axiosConfig.put(`/admin/alerts-types-hidden-send/${alertId}`, {
      hidden: checked,
    });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function setImmediateAlert(alertId: number, checked: any) {
  try {
    await axiosConfig.put(`/admin/alerts-types-immediate-send/${alertId}`, {
      immediateSend: checked,
    });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function createNewAlertAction(alertId: number) {
  try {
    const body = {
      actions: [
        {
          sendStaff: "all",
          sendToStaffGroupId: null,
          sendToParents: false,
        },
      ],
    };
    await axiosConfig.patch(`/admin/alerts-types/${alertId}`, body);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getAlertActionById(alertId: number) {
  try {
    const alerts = await getAlerts("");
    const currentAlert = alerts.data.find((alert) => alert.id === alertId);
    if (!currentAlert) {
      throw Error("Alert not found");
    }
    return currentAlert.actions;
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function editAlertActionById(
  alertId: number,
  alertActionId: number,
  state: any
) {
  try {
    const body = {
      actions: [
        {
          id: alertActionId,
          ...state,
        },
      ],
    };
    await axiosConfig.patch(`/admin/alerts-types/${alertId}`, body);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function deleteAlertAction(alertActionId: number): Promise<void> {
  try {
    await axiosConfig.delete(`/admin/alerts-types/actions/${alertActionId}`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

//allow query with all filters combined
export async function getHistoryOfAlerts(
  page: number,
  limit: number,
  alertTypeId: string,
  date_from: string | undefined,
  date_to: string | undefined,
  title: any = "",
  alert_type: any = ""
): Promise<{ total: number; data: AlertHistoryResponse[] }> {
  const today = moment().format("YYYY-MM-DD");

  try {
    // Step 1: Base pagination & search query
    const pagination = `page=${page}&limit=${limit}${title ? `&search=${title}` : ""}${(alert_type && alert_type !== "all") ? `&alert_type=${alert_type}` : ""}`;

    // Step 2: Alert type filter
    const alertTypeFilter =
      alertTypeId && alertTypeId !== "all"
        ? `&filter[alertTypeId][eq]=${alertTypeId}`
        : "";

    // Step 3: Date filters
    const dateFromFilter =
      date_from && moment(date_from).format("YYYY-MM-DD") !== today
        ? `&filter[created_at][gt]=${date_from}`
        : "";

    const dateToFilter =
      date_to && moment(date_to).format("YYYY-MM-DD") !== today
        ? `&filter[created_at][lt]=${date_to}`
        : "";

    // Step 4: Full query
    const fullQuery = `${pagination}${alertTypeFilter}${dateFromFilter}${dateToFilter}`;
    console.log("API URL:", `/admin/alerts?${fullQuery}`);

    const response = await axiosConfig.get(`/admin/alerts?${fullQuery}`);
    return {
      total: response.data.meta.total,
      data: response.data.data,
    };
  } catch (e) {
    const err = e as AxiosError | Error;
    console.error("API ERROR:", err);
    throw new ApiError(err);
  }
}


export async function sendFcmToken(token: string): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.post(
      "/admin/update-fcm-token", { fcm_token: token }
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getAlertsInProgress(): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.get(
      "/admin/alerts/in-progress"
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getShootAlertsInProgress(): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.get(
      "/admin/high-alerts"
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getForwardShootAlerts(): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.get(
      "/admin/forward-high-alerts"
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getForwardOtherAlerts(): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.get(
      "/admin/forward-other-alerts"
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function getNotifications(): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.get(
      "/admin/admin-notifications"
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function sendReadNotification(id: number): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.get(
      `/admin/read-admin-notification/${id}`
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function deleteAllNotifications(): Promise<AlertResponse[]> {
  try {
    const AlertTypeResponse = await axiosConfig.get(
      `/admin/remove-all-notification`
    );
    return AlertTypeResponse.data.data as AlertResponse[];
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function closeShootAlertInProgress(alertId: string): Promise<void> {
  try {
    await axiosConfig.delete(`/admin/high-alert/${alertId}`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function closeForwardShootAlertInProgress(alertId: string): Promise<void> {
  try {
    await axiosConfig.delete(`/admin/forward-high-alert/${alertId}`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function approvedShootAlertInProgress(alertId: string): Promise<void> {
  try {
    await axiosConfig.put(`/admin/high-alert/${alertId}`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function forwardShootAlertInProgress(data: any): Promise<void> {
  try {
    return await axiosConfig.patch(`/admin/high-alert/${data?.id}`, { data: data?.body });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function forwardInProgress(data: any): Promise<void> {
  try {
    return await axiosConfig.patch(`/admin/other-alert/${data?.id}`, { data: data?.body });
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function approvedInProgress(alertId: string): Promise<void> {
  try {
    return await axiosConfig.put(`/admin/other-alert/${alertId}`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}

export async function closeAlertInProgress(alertId: string): Promise<void> {
  try {
    await axiosConfig.post(`/admin/alerts/${alertId}/finish`);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}


export async function deleteAllAlerts(
  data: [],
  type: any,
): Promise<void> {
  try {
    const body = { alert_ids: data, type };
    await axiosConfig.post("/admin/delete-all-alerts", body);
  } catch (e) {
    const err = e as AxiosError | Error;
    throw new ApiError(err);
  }
}